import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';
import { isNumberGreaterThanZero } from '@thesavingsgroup/utils/isNumberGreaterThanZero';
import { toNumber } from 'lodash';

import { RefinanceGoal } from '../enums/RefinanceGoal';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromMailCode } from '../types/HydrateFromMailCode';

export const toApplyStateFromMailCode = (
  mailCode: HydrateFromMailCode,
): Partial<ApplyState> => {
  const applicationType = isInEnum(mailCode.applicationType, ApplicationType)
    ? mailCode.applicationType
    : ApplicationType.REFINANCE;

  const isRefinance = applicationType === ApplicationType.REFINANCE;

  const isPurchaseOrLeaseBuyout =
    applicationType === ApplicationType.PURCHASE ||
    applicationType === ApplicationType.LEASE_BUYOUT;

  const payoffAmount: string | null = isRefinance
    ? mailCode.payoffAmount
    : null;

  const purchasePrice: string | null =
    isPurchaseOrLeaseBuyout &&
    isNumberGreaterThanZero(toNumber(mailCode.purchasePrice))
      ? String(mailCode.purchasePrice)
      : null;

  const refinanceGoal: RefinanceGoal | null = isRefinance
    ? RefinanceGoal.LOWER_PAYMENT
    : null;

  return {
    applicationType,
    payoffAmount,
    purchasePrice,
    refinanceGoal,
  };
};
